import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "lti-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "lti-settings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
});
